export const StatusButtonOptions = {
  APPROVE: 'approve',
  REJECT: 'reject',
};
